import gql from "graphql-tag";

export default gql`
  query searchShow($text: String!) {
    search: tmdbSearchShow(text: $text)
  }
`